import { TopicPartQuestion } from "../../topicPartQuestion/entities/TopicPartQuestion";

export interface TopicPart {
  id: string;
  topicId: string;
  title: string;
  description?: string | null;
  timing?: number;
  videoLink?: string | null;
  /// URL du fichier vidéo enregistré, ou fichier à téléverser. Exclusif de [videoLink].
  videoFile?: string | File | null;
  /// URL du fichier audio enregistré, ou fichier à téléverser.
  audioFile?: string | File | null;
  contentText?: string;
  additionalText?: string | null;
  rank?: number;
  comments?: string;
  answerTogether?: boolean;
  isSynthesisPart?: boolean;
  topicPartQuestions?: TopicPartQuestion[];
  created?: string;
  updated?: string;
}

export type TopicPartFormData = Omit<
  TopicPart,
  "id" | "rank" | "created" | "updated"
>;

export const emptyTopicPart = (topicId: string): TopicPartFormData => ({
  topicId,
  title: "",
  description: "",
  timing: 0,
  videoLink: null,
  videoFile: null,
  audioFile: null,
  contentText: "",
  additionalText: null,
  answerTogether: false,
  isSynthesisPart: false,
});
